export default [
    {
        // [1]
        key: "created_by",
        label: "Created By",
        visible: true,
    },
    {
        // [1]
        key: "abbreviation",
        label: "Attendance",
        visible: true,
    },
    {
        // [1]
        key: "status",
        label: "Status",
        visible: true,
    },
    {
        // [1]
        key: "description",
        label: "Description",
        visible: true,
    },
    {
        // [1]
        key: "observation",
        label: "Observation",
        visible: true,
    },
]